import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {environment} from '~env/environment';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParamService {

  private data: string;
  private readonly dataMonitoramento$: BehaviorSubject<string>;

  constructor(private datePipe: DatePipe) {
    this.data = environment?.experimentalFeatures?.fixedDate || '';
    this.dataMonitoramento$ = new BehaviorSubject<string>(this.data);
  }

  alterarData(data: string): void {
    this.data = data;
    this.dataMonitoramento$.next(this.data);
  }

  reset(): void {
    this.alterarData(environment.experimentalFeatures?.fixedDate ?? '');
  }

  get dataMonitoramento(): string {
    return `${this.data || this.datePipe.transform(Date.now(), 'yyyy-MM-dd')}`;
  }

  get dateMonitoramento(): Date {
    const date = this.data ? this.data.concat('T00:00:00') : '';
    return date ? new Date(date) : new Date();
  }

  get data$(): BehaviorSubject<string> {
    return this.dataMonitoramento$;
  }

  get isNow(): boolean {
    return this.dataMonitoramento === this.datePipe.transform(Date.now(), 'yyyy-MM-dd');
  }
}
